/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_PARTS } from '../../actions.type'
import {
  CREATE_PART,
  REMOVE_PART,
  SET_PART_ALL_REQUEST,
  SET_PART_ALL_VALUE,
  UPDATE_PART
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  partAllValue: (state) => state.all.value,
  partAllRequest: (state) => state.all.request,
  partAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_PARTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('part', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_PART_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_PART_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_PART_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_PART_ALL_VALUE, data)
    } catch (e) {
      commit(SET_PART_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_PART({ commit }, value) {
    commit(CREATE_PART, value)
  },

  async SOCKET_UPDATE_PART({ commit }, value) {
    commit(UPDATE_PART, value)
  },

  async SOCKET_REMOVE_PART({ commit }, id) {
    commit(REMOVE_PART, id)
  }
}

const mutations = {
  [SET_PART_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_PART_ALL_VALUE](state, parts) {
    state.all.value = parts
  },
  [UPDATE_PART](state, updatedPart) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedPart.id }),
      1,
      updatedPart
    )
  },
  [CREATE_PART](state, createdPart) {
    state.all.value.push(createdPart)
  },
  [REMOVE_PART](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
